import { GetPurgeScheduleResponse } from '@cbinsights/userv2service/userv2service';
import { UseQueryResult, useQuery } from 'react-query';
import { GetPurgeScheduleByUserId } from '.';
import { getPurgeScheduleByUserId } from '../api/GetPurgeScheduleByUserId';

type Params = Parameters<typeof getPurgeScheduleByUserId>[0];
type Return = GetPurgeScheduleResponse;

export const useGetPurgeScheduleByUserIdQuery = ({
  enabled = false,
  params,
}: {
  enabled: boolean;
  params: Params;
}): UseQueryResult<Return, Error> =>
  useQuery<Return, Error, Return, [GetPurgeScheduleByUserId, Params]>(
    ['GetPurgeScheduleByUserId', params],
    () => getPurgeScheduleByUserId(params),
    {
      enabled,
      notifyOnChangeProps: ['data', 'isFetching'],
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
      retry: false,
    }
  );
